type AsssetPowerModesMapping = {
  [key in ASSET_POWER_MODES]: string;
};

enum ASSET_POWER_MODES {
  PLUGGED = 'Plugged',
  CABLE = 'Cable',
  SOLAR = 'Solar',
  UNPOWERED = 'Unpowered',
  THERMOKING_CABLE_POWERED = 'Thermo King cable powered',
  THERMOKING_CABLE_CONNECTED = 'Thermo King cable connected',
  CABLE_POWERED = 'Cable powered',
  CABLE_CONNECTED = 'Cable connected',
  INVALID = 'Invalid',
  BATTERY_POWERED = 'Battery powered',
}

const ASSET_MODES_MAPPING: AsssetPowerModesMapping = {
  [ASSET_POWER_MODES.PLUGGED]: $localize`Cable Powered`,
  [ASSET_POWER_MODES.CABLE]: $localize`Cable Powered`,
  [ASSET_POWER_MODES.SOLAR]: $localize`Solar Powered`,
  [ASSET_POWER_MODES.UNPOWERED]: $localize`Unpowered`,
  [ASSET_POWER_MODES.INVALID]: $localize`Invalid`,
  [ASSET_POWER_MODES.THERMOKING_CABLE_POWERED]: $localize`Thermo King cable powered`,
  [ASSET_POWER_MODES.THERMOKING_CABLE_CONNECTED]: $localize`Thermo King cable connected`,
  [ASSET_POWER_MODES.CABLE_POWERED]: $localize`Cable powered`,
  [ASSET_POWER_MODES.CABLE_CONNECTED]: $localize`Cable connected`,
  [ASSET_POWER_MODES.BATTERY_POWERED]: $localize`Battery powered`,
};

export { ASSET_POWER_MODES, ASSET_MODES_MAPPING };
